import { useAppHealthStore } from '@/stores/use-app-health-store';

/**
 * T17 — offline bills wait in IndexedDB until they sync. Without persistent
 * storage the browser may evict that database when the device runs low on
 * space, so ask once at start-up and warn when the browser says no.
 *
 * Resolves to true when storage is persistent, false when refused, and null
 * when the browser has no StorageManager API (nothing to ask).
 */
export async function ensurePersistentStorage(): Promise<boolean | null> {
  const storage = typeof navigator !== 'undefined' ? navigator.storage : undefined;
  if (!storage?.persist) return null;
  let granted = false;
  try {
    granted = (await storage.persisted?.()) || (await storage.persist());
  } catch {
    granted = false;
  }
  useAppHealthStore
    .getState()
    .setStorageWarning(
      granted
        ? null
        : 'This browser may clear offline bills when the device is low on space. Install Orio360 POS as an app to keep them safe.',
    );
  return granted;
}
